import {configureStore} from '@reduxjs/toolkit';
import listOfValuesSliceReducer from './common/listOfValueSlice'
import alertSliceReducer from './opportunities/alertSlice'
import coursesSliceReducer from './courses/coursesSlice'


const store = configureStore({
     reducer: {
        listOfValues : listOfValuesSliceReducer,        
        alert: alertSliceReducer,
        courses: coursesSliceReducer,
     }
})


export default store;
